/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { Table, Alert } from 'react-bootstrap';
import { Modal } from 'sa-ui';
import moment from 'moment';
import messages from './notifyStudentModalMessages';
import './NotifyStudentModal.scss';

const NotifyStudentModal = ({ intl, show, onClose, onContinue, students, hasError }) => {
  const [noneSelected, setNoneSelected] = useState(false);
  const [allStudentsSelected, setAllStudentsSelected] = useState(false);
  const [studentsSelected, setStudentsSelected] = useState({});
  const [studentsArr, setStudentsArr] = useState([]);

  function handleSendEmail() {
    const idStudents = [];

    Object.keys(studentsSelected).map((s) => {
      if (studentsSelected[s] === true) {
        idStudents.push(s);
      }
    });

    onContinue(idStudents);
  }

  function handleArrStudent(idStudent) {
    setStudentsSelected((studentsSelected) => ({
      ...studentsSelected,
      [idStudent]: studentsSelected[idStudent] !== true,
    }));
  }

  function handleSelectAll() {
    if (allStudentsSelected) {
      setAllStudentsSelected(false);
      studentsArr.map(
        (s) =>
          s.email !== '-' &&
          setStudentsSelected((studentsSelected) => ({ ...studentsSelected, [s.id]: false })),
      );
    } else {
      setAllStudentsSelected(true);
      studentsArr.map(
        (s) =>
          s.email !== '-' &&
          setStudentsSelected((studentsSelected) => ({
            ...studentsSelected,
            [s.id]: true,
          })),
      );
    }
  }

  useEffect(() => {
    if (students) {
      setStudentsArr(
        students.map((student) => ({
          id: student.id,
          name: `${student.firstname} ${student.lastname}`,
          email: student.email || '-',
          notified: student.notified,
        })),
      );
    }

    return () => {
      setStudentsArr([]);
    };
  }, [students]);

  useEffect(() => {
    setStudentsSelected(
      studentsArr.reduce((acc, s) => {
        if (s.email !== '-') {
          acc[s.id] = !s.notified;
        }
        return acc;
      }, {}),
    );
    return () => {
      setStudentsSelected({});
    };
  }, [studentsArr]);

  useEffect(() => {
    if (Object.keys(studentsSelected).find((key) => studentsSelected[key] === false)) {
      setAllStudentsSelected(false);
    } else {
      setAllStudentsSelected(true);
    }

    if (!Object.keys(studentsSelected).find((key) => studentsSelected[key] === true)) {
      setNoneSelected(true);
    } else {
      setNoneSelected(false);
    }

    return () => {
      setAllStudentsSelected(false);
      setNoneSelected(false);
    };
  }, [studentsSelected]);

  return (
    <Modal
      id="notify-student-modal"
      large
      fullscreen
      show={show}
      onClose={onClose}
      icon="ti-email"
      title={intl.formatMessage(messages.title)}
      buttons={[
        {
          label: intl.formatMessage(messages.cancel),
          onClick: onClose,
        },
        {
          label: intl.formatMessage(messages.sendEmail),
          onClick: () => handleSendEmail(),
          primary: true,
          disabled: noneSelected,
          style: { cursor: noneSelected ? 'not-allowed' : 'pointer' },
        },
      ]}
    >
      <div>{intl.formatMessage(messages.subtitle)}</div>

      {hasError && (
        <Alert style={{ marginTop: '40px' }} variant="danger">
          {intl.formatMessage(messages.genericError)}
        </Alert>
      )}

      <Table responsive="sm" style={{ marginTop: '40px' }}>
        <thead>
          <tr>
            <th>{intl.formatMessage(messages.studentName)}</th>
            <th>{intl.formatMessage(messages.email)}</th>
            <th>{intl.formatMessage(messages.notifiedIn)}</th>
            <th>
              <input
                className="inputNotify"
                type="checkbox"
                onChange={() => handleSelectAll()}
                checked={allStudentsSelected}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {studentsArr.map((student) => (
            <tr>
              <td>{student.name}</td>
              <td>{student.email}</td>
              <td>{student.notified ? moment(student.notified).format('D/M/YYYY - h:mm') : '-'}</td>
              <td>
                {student.email !== '-' && (
                  <input
                    className={`inputNotify ${studentsSelected[student.id] ? 'checked' : ''}`}
                    type="checkbox"
                    checked={studentsSelected[student.id]}
                    value={studentsSelected[student.id]}
                    onChange={() => handleArrStudent(student.id)}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Modal>
  );
};

export default injectIntl(NotifyStudentModal);
